import { useEffect, useState } from 'react';

const useSessionCountDown = () => {
  const decodeToken = JSON.parse(localStorage.getItem('decodedToken'));
  const currentTime = Math.ceil(Date.now() / 1000);
  const sessionTime = decodeToken?.exp - currentTime;
  const additionlSessionTime = sessionTime + 4500;

  const [timer, setTimer] = useState(sessionTime);
  const [timerColor, setTimerColor] = useState('green');

  useEffect(() => {
    const timerId = setTimeout(() => {
      const newTimer = sessionTime - 1;
      const newAdditionalTimer = additionlSessionTime - 1;

      if (newTimer >= 1) {
        setTimer(newTimer);
        setTimerColor('green');
      } else {
        setTimer(newAdditionalTimer);
        setTimerColor('#e68600');
      }

      if (newAdditionalTimer <= 0) setTimerColor('red');
    }, 1000);

    return () => {
      clearTimeout(timerId);
    };
  }, [additionlSessionTime, sessionTime]);

  return {
    timer,
    timerColor,
  };
};

export default useSessionCountDown;
